import 'css-chunksrc/client/common/layout/panelResizer/styles.scss';export default {
  "panelResizer": "_panelResizer_1887v_1",
  "panel": "_panel_1887v_1",
  "track": "_track_1887v_12",
  "thumb": "_thumb_1887v_16",
  "thumbIcon": "_thumbIcon_1887v_32",
  "unselectable": "_unselectable_1887v_38"
};